import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=44a85a4a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a85a4a')) {
      api.createRecord('44a85a4a', component.options)
    } else {
      api.reload('44a85a4a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=44a85a4a&", function () {
      api.rerender('44a85a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KXMEmhPpqR6W/JS/pricehelp.vue"
export default component.exports